import React from 'react';
import Icon from '../../../components/AppIcon';

const RolePerformanceCards = ({ selectedRole }) => {
  const roleData = {
    all: [
      { label: 'Total Staff', value: 48, icon: 'Users', color: 'var(--color-primary)' },
      { label: 'Active Today', value: 42, icon: 'UserCheck', color: 'var(--color-success)' },
      { label: 'On Leave', value: 6, icon: 'Calendar', color: 'var(--color-warning)' },
      { label: 'Avg Performance', value: '87.5%', icon: 'TrendingUp', color: 'var(--color-accent)' }
    ],
    trainer: [
      { label: 'Total Trainers', value: 18, icon: 'Dumbbell', color: 'var(--color-primary)' },
      { label: 'Active Clients', value: 187, icon: 'Users', color: 'var(--color-success)' },
      { label: 'Sessions Today', value: 34, icon: 'Calendar', color: 'var(--color-warning)' },
      { label: 'Avg Rating', value: '4.8/5', icon: 'Star', color: 'var(--color-accent)' }
    ],
    staff: [
      { label: 'Front Desk Staff', value: 12, icon: 'UserCheck', color: 'var(--color-primary)' },
      { label: 'Check-ins Today', value: 342, icon: 'CheckCircle', color: 'var(--color-success)' },
      { label: 'Avg Response Time', value: '45s', icon: 'Clock', color: 'var(--color-warning)' },
      { label: 'Service Rating', value: '4.7/5', icon: 'Star', color: 'var(--color-accent)' }
    ],
    maintenance: [
      { label: 'Maintenance Staff', value: 8, icon: 'Wrench', color: 'var(--color-primary)' },
      { label: 'Repairs Completed', value: 42, icon: 'CheckCircle', color: 'var(--color-success)' },
      { label: 'Avg Response Time', value: '18m', icon: 'Clock', color: 'var(--color-warning)' },
      { label: 'Cleanliness Score', value: '4.9/5', icon: 'Star', color: 'var(--color-accent)' }
    ],
    manager: [
      { label: 'Management Team', value: 10, icon: 'Briefcase', color: 'var(--color-primary)' },
      { label: 'Team Performance', value: '89%', icon: 'TrendingUp', color: 'var(--color-success)' },
      { label: 'Staff Retention', value: '92%', icon: 'UserCheck', color: 'var(--color-warning)' },
      { label: 'Goal Achievement', value: '88%', icon: 'Target', color: 'var(--color-accent)' }
    ]
  };

  const currentData = roleData?.[selectedRole] || roleData?.all;

  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        {selectedRole === 'all' ? 'Overall' : selectedRole?.charAt(0)?.toUpperCase() + selectedRole?.slice(1)} Performance
      </h3>
      <div className="grid grid-cols-2 gap-4">
        {currentData?.map((item, idx) => (
          <div key={idx} className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${item?.color}15` }}>
                <Icon name={item?.icon} size={20} color={item?.color} />
              </div>
            </div>
            <div className="text-sm text-muted-foreground mb-1">{item?.label}</div>
            <div className="text-2xl font-semibold text-foreground data-text">{item?.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RolePerformanceCards;